import { render, staticRenderFns } from "./robot.vue?vue&type=template&id=8524793c&scoped=true&lang=pug&"
import script from "./robot.vue?vue&type=script&lang=js&"
export * from "./robot.vue?vue&type=script&lang=js&"
import style0 from "./robot.vue?vue&type=style&index=0&id=8524793c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8524793c",
  null
  
)

export default component.exports